export default __webpack_public_path__ + "static/media/logo_beige.28c41ddb.png";